import { tvaRateCertain } from '@shared/alertis-siret.js'
import { formatPrice } from './currencyFormatters.js'

/**
 * Le taux de TVA qu'appliquera le devis, déduit de ce que le demandeur a déjà
 * dit de lui (particulier ou professionnel, n° de TVA, activité, financement) :
 * la même règle que l'e-mail et le PDF du devis. `null` tant qu'il est
 * incertain : on ne montre alors que le HT plutôt qu'un TTC peut-être faux.
 */
export function tauxTvaDeLaDemande(demande) {
  return tvaRateCertain(demande)
}

const enTtc = (montantHT, taux) => (taux === null || taux === undefined ? null : formatPrice(montantHT * (1 + taux)))

/** « 3 400,00 € HT · 4 080,00 € TTC », ou le HT seul quand le taux est incertain. */
export function enHtEtTtc(montantHT, taux) {
  const ttc = enTtc(montantHT, taux)
  return ttc ? `${formatPrice(montantHT)} HT · ${ttc} TTC` : `${formatPrice(montantHT)} HT`
}

/**
 * Les lignes d'un tarif, chacune en HT et en TTC : le prix d'une unité (un
 * groupe, une place) quand il y en a plusieurs, puis le total. `unitaireAvant`
 * est le prix d'une unité commandée seule, quand le volume le fait baisser :
 * il accompagne la ligne unitaire pour être affiché barré.
 */
export function lignesTarif({ total, unitaire, unitaireAvant, quantite, unite, taux }) {
  const ligne = (label, ht, estTotal) => ({
    label,
    ht: formatPrice(ht),
    ttc: enTtc(ht, taux),
    total: estTotal
  })
  const prixUnitaire = unitaire === null || unitaire === undefined ? NaN : Number(unitaire)
  const lignes = []
  if (Number(quantite) > 1 && Number.isFinite(prixUnitaire)) {
    const parUnite = ligne(`Par ${unite}`, prixUnitaire, false)
    if (Number(unitaireAvant) > prixUnitaire) {
      parUnite.htAvant = formatPrice(Number(unitaireAvant))
      parUnite.ttcAvant = enTtc(Number(unitaireAvant), taux)
    }
    lignes.push(parUnite)
  }
  lignes.push(ligne('Total', Number(total), true))
  return lignes
}

/** « Vous économisez 80,00 € HT par groupe, soit 400,00 € HT au total. » */
export function phraseEconomie(remise, unite) {
  if (!remise) return null
  return `Vous économisez ${formatPrice(remise.parGroupe)} HT par ${unite}, soit ${formatPrice(remise.total)} HT au total.`
}
